module.exports = __webpack_public_path__ + "img/_business.b996b826.svg";